import {GPTypeItem} from "./gp-typeitem";
import {get} from "svelte/store";
import {preferredNames} from "./gp";

export class GPTypePlant extends GPTypeItem {
    constructor(gpt) {
        super();

        this.typeName = "GPTypePlant"
        this.id = parseInt(gpt["-id"]);
        this.type = gpt["-tp"];
        this.name = gpt["-nm"];
        this.altname1 = gpt["-nm1"];
        this.altname2 = gpt["-nm2"];
        this.altname3 = gpt["-nm3"];
        this.altname4 = gpt["-nm4"];
        this.altname5 = gpt["-nm5"];
        this.image = gpt['-img'].replace(/ /g, '-').toLowerCase();
        this.latin = gpt["-lt"];
        this.area = gpt["-ar"];
        this.area_max = gpt["-arm"];
        this.height = gpt["-hi"];
        this.height_from = gpt["-himin"];
        this.height_to = gpt["-himax"];
        this.diameter = gpt["-di"];
        this.flower_color = gpt["-fl_c"];
        this.blossom_from = parseInt(gpt["-bl_f"]) ? parseInt(gpt["-bl_f"]) : null;
        this.blossom_to = parseInt(gpt["-bl_t"]) ? parseInt(gpt["-bl_t"]) : null;
        this.leaf_color = gpt["-cl"];
        this.soilTypePH_acid = gpt["-sk_a"];
        this.soilTypePH_normal = gpt["-sk_n"];
        this.soilTypePH_base = gpt["-sk_b"];
        this.soilHumidity_arid = gpt["-sh_a"];
        this.soilHumidity_normal = gpt["-sh_n"];
        this.soilHumidity_wet = gpt["-sh_w"];
        this.soilTypeQuality_rich = gpt["-sq_r"];
        this.soilTypeQuality_normal = gpt["-sq_n"];
        this.soilTypeQuality_poor = gpt["-sq_p"] ;
        this.light_full = gpt["-l_f"];
        this.light_half = gpt["-l_h"];
        this.light_dark = gpt["-l_d"];
        this.shape = gpt["-sh"];
        this.details = gpt["-dt"];
        this.hedgeplant = gpt["-hp"];
        this.coverplant = gpt["-cp"];
        this.evergreen = gpt["-ev"];
        this.support = gpt["-sp"];
        this.season_w = gpt["-s_w"];
        this.season_l = gpt["-s_l"];
        this.season_j = gpt["-s_j"];
        this.season_z = gpt["-s_z"];
        this.best_season = gpt["bs"];
        this.premium = gpt["-pr"];
        this.package = gpt["package"];

        //TODO: remove
        // if (gpt['-nm'][0]==='A') {
        //     gpt['package'] = "vegetables"
        // };
        this.enabled = GPSettings.products[gpt['package'] + "_database"].active;
        this.visible = true;
        this.alternativeNames = "";
        if (gpt['-nm1']) this.alternativeNames = gpt['-nm1'];
        if (gpt['-nm2']) this.alternativeNames += ", " + gpt['-nm2'];
        if (gpt['-nm3']) this.alternativeNames += ", " + gpt['-nm3'];
        if (gpt['-nm4']) this.alternativeNames += ", " + gpt['-nm4'];
        if (gpt['-nm5']) this.alternativeNames += ", " + gpt['-nm5'];

        if (this.height>800)
            this.heightClass = "xxxl";
        else if (this.height>1000)
            this.heightClass = "xxl";
        else if (this.height>700)
            this.heightClass = "xl";
        else if (this.height>500)
            this.heightClass = "l";
        else if (this.height>300)
            this.heightClass = "m";
        else if (this.height>150)
            this.heightClass = "s";
        else if (this.height>100)
            this.heightClass = "xs";
        else if (this.height>50)
            this.heightClass = "xxs";
        else this.heightClass = "xxxs";

    }

    staticGetPathForImage(season) {
        var size;
        season = this.staticMapMonth2Season(season);
        if (!season) season = this.best_season;

        let imgseason = this['season_' + season];
        if (!imgseason) return "img/pixel.png";

        //Keep in sync with data in api apiGetAllAssetPaths()
        if (this.height > 700) //TODO - take scene size into account
            size = "b";
        else
            size = "m";
        return GPSettings.plantsAddr(this, false, size) + size + 'v4/' + this.image + '_' + this['season_' + season] + '.webp';
    }

    staticGetPathForThumb(season, noEmpty = false) {
        var size = "s";
        season = this.staticMapMonth2Season(season);
        if (!season) season = this.best_season;

        let imgseason = this['season_' + season];
        if (!imgseason && !noEmpty) return "img/pixel.png";
        if (!imgseason) season = this.best_season;

        return GPSettings.plantsAddr(this, true, size) + size + 'v4/' + this.image + '_' + this['season_' + season] + '.webp';
    }

    staticMapMonth2Season(month) {
        if ("wljz".indexOf(month) >= 0) return month;

        let month2season = ["z","z","w","w","w","l","l","l","l","j","j","z"];

        if (this.blossom_from && this.blossom_to) {
            let normal_season;
            if (this.best_season === "w") normal_season = "l";
            if (this.best_season === "l") normal_season = "w";
            if (this.best_season === "j") normal_season = "l";
            if (this.best_season === "z") normal_season = "l";

            for (let i = 1; i <= 12; i++) {
                if (i >= this.blossom_from && i <= this.blossom_to)
                    month2season[i-1] = this.best_season;
                if (i < this.blossom_from && month2season[i-1] === this.best_season)
                    month2season[i-1] = normal_season;
                if (i > this.blossom_to && month2season[i-1] === this.best_season)
                    month2season[i-1] = normal_season;
            }

        }
        return month2season[month - 1];
    }

    getName() {
        if (get(preferredNames) === "latin")
            return this.latin;
        else
            return this.name;
    }
}